import React from "react";
import {Button, Form, Input, message} from "antd";
import {MinusCircleOutlined, PlusOutlined} from "@ant-design/icons";
import {AuthGroup} from "../../domains/auth-group";
import {FormInstance} from "antd/es/form";
import {request} from "../../utils/utils";

interface AuthGroupEditState {
    group: AuthGroup
    mask: number
    onSubmitSuccess: () => void
}


export default class AuthGroupEdit extends React.Component<AuthGroupEditState, any> {
    formRef = React.createRef<FormInstance>()

    layout = {
        labelCol: {span: 4},
        wrapperCol: {span: 18}
    };

    componentDidMount() {
        if ((this.props.mask & 1) === 1) {
            this.formRef.current!!.setFieldsValue({
                name: this.props.group.name,
                grantedPaths: this.props.group.grantedPathList,
            })
        }
    }

    fillUpForm = (record: AuthGroup) => {
        if (record) {
            this.setState({group: record})
            this.formRef.current!!.setFieldsValue({
                name: record.name,
                grantedPaths: record.grantedPathList,
            })
        }
    }

    private handleFormSubmit = (value: any) => {
        let form = new FormData()
        form.append("name", value.name)
        if (value.grantedPaths) {
            form.append("paths", value.grantedPaths.join(","))
        }

        if ((this.props.mask & 2) === 2) {
            form.append("parent", this.props.group.id)
            request({
                method: "POST",
                url: "/gateway/authgroup/add",
                data: form,
                headers: {'ContentType': 'application/x-www-form-urlencoded;'}
            }).then((res) => {
                this.formRef.current?.resetFields()
                this.props.onSubmitSuccess()
            }).catch(res => {
                message.info("路由配置失败，请稍后重试" + res)
            })
        } else if ((this.props.mask & 1) === 1) {
            form.append("id", this.props.group.id)
            request({
                method: "POST",
                url: "/gateway/authgroup/update",
                data: form,
                headers: {'ContentType': 'application/x-www-form-urlencoded;'}
            }).then((res) => {
                this.formRef.current?.resetFields()
                this.props.onSubmitSuccess()
            }).catch(res => {
                message.info("路由配置失败，请稍后重试" + res)
            })
        }
    }

    submitForm = () => {
        this.formRef.current!!.submit();
    }

    render() {
        return (
            <Form {...this.layout} ref={this.formRef} onFinish={this.handleFormSubmit}>
                <Form.Item label={"名称"} name={"name"}>
                    <Input/>
                </Form.Item>
                <Form.Item label={"授权的路径"}>
                    <Form.List name={"grantedPaths"}>
                        {(fields, {add, remove}) => (
                            <>
                                {fields.map((field, index) => (
                                    <div style={{
                                        display: "flex",
                                        alignItems: "center",
                                        marginBottom: '24px'
                                    }}>
                                        <Form.Item {...field} style={{
                                            margin: "0 5px 0 0",
                                            width: '100%'
                                        }}>
                                            <Input style={{marginRight: 5}}/>

                                        </Form.Item>
                                        <MinusCircleOutlined onClick={() => remove(field.name)}/>
                                    </div>

                                ))}
                                <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined/>}>
                                    新增授权路径
                                </Button>
                            </>
                        )}
                    </Form.List>
                </Form.Item>
            </Form>
        )
    }
}
